import React, { useMemo } from "react";
import {
  SignatureDate,
  SignatureItemContainer,
  SignatureMemberDiv,
  SignatureMemberEmail,
  SignatureMemberIndex,
  SignatureMemberInfo,
  SignatureMemberName,
  SignatureStatus,
  SignatureStatusDiv,
} from "./styles";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { ISignature } from "../DocumentItem";
import { format, parseISO } from "date-fns";
import ptLocale from "date-fns/locale/pt-BR";
import esLocale from "date-fns/locale/es";
import enLocale from "date-fns/locale/en-US";
import { useTranslation } from "react-i18next";
import {
  getDateTimeFormats,
  getDateTimeLocale,
} from "../../../../../utils/get-date-time-locale";

interface ISignatureItemProps {
  signature: ISignature;
  index: number;
}

const locales = {
  pt: ptLocale,
  es: esLocale,
  en: enLocale,
};

const SignatureItem = ({ index, signature }: ISignatureItemProps) => {
  const { i18n, t } = useTranslation();
  const language = i18n.language as keyof typeof locales;

  const isoDate = `${signature.date}Z`;

  const formattedDate = useMemo(() => {
    return format(new Date(isoDate), getDateTimeFormats(language), {
      locale: getDateTimeLocale(i18n.language),
    });
  }, [signature, language]);

  return (
    <SignatureItemContainer>
      <SignatureMemberDiv>
        <SignatureMemberIndex>{index + 1}</SignatureMemberIndex>
        <SignatureMemberInfo>
          <SignatureMemberName>{signature.memberName}</SignatureMemberName>
          <SignatureMemberEmail>{signature.memberEmail}</SignatureMemberEmail>
        </SignatureMemberInfo>
      </SignatureMemberDiv>

      <SignatureStatusDiv>
        <div>
          <BorderColorIcon
            style={{
              color: "#000000",
              height: "12px",
              width: "12px",
            }}
          />
          <SignatureStatus>
            {t(`forms.minutes.signatures.status.${signature.status}`)}
          </SignatureStatus>
        </div>
        <SignatureDate>{formattedDate}</SignatureDate>
      </SignatureStatusDiv>
    </SignatureItemContainer>
  );
};

export default SignatureItem;
